export default {
  metadata: {
    version: '1.0.0',
    id: 'toast-1.0.0',
    name: 'JDSToast'
  },
  hierarchy: {
    'root-container': [
      {
        'base-container': [
          'left-slot',
          {
            'center-container': ['heading-jds-text', 'support-jds-text']
          },
          'close-jds_notification_button',
          'right-slot'
        ]
      },
      {
        'buttons-container': [
          'secondary-jds_notification_button',
          'primary-jds_notification_button'
        ]
      }
    ]
  },
  base: {
    'root-container': {
      width: '{t_0}',
      'max-width': '{t_1}',
      'border-radius': '{t_2}',
      'background-color': '{t_3}',
      'flex-direction': '{t_4}',
      gap: '{t_5}',
      'padding-top': '{t_6}',
      'padding-right': '{t_7}',
      'padding-bottom': '{t_8}',
      'padding-left': '{t_9}',
      'enter-animation-name': 'slideVerticallyUp',
      'exit-animation-name': 'slideVerticallyDown',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      transition: {
        property: ['translate-x', 'translate-y'],
        duration: '{medium}',
        'timing-function': '{easeJoyfulExit}'
      },
      hidden: true
    },
    'base-container': {
      gap: '{t_10}',
      'flex-direction': '{t_12}',
      'justify-content': '{t_13}',
      'align-items': '{t_14}',
      width: '{t_11}'
    },
    'center-container': {
      'flex-direction': '{t_15}',
      'justify-content': '{t_16}',
      'align-items': '{t_17}',
      gap: '{t_18}',
      flex: 1
    },
    'close-jds_notification_button': {
      hidden: false,
      icon: 'ic_close',
      kind: 'tertiary'
    },
    'buttons-container': {
      gap: '{t_20}',
      'flex-direction': '{t_21}',
      'justify-content': '{t_22}',
      width: '{t_19}'
    },
    'secondary-jds_notification_button': {
      kind: 'tertiary'
    },
    'right-slot': {
      hidden: true
    },
    'heading-jds-text': {
      'font-family': '{text_137}',
      color: '{text_19}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 2,
      maxLines: 2
    },
    'support-jds-text': {
      'font-family': '{text_147}',
      color: '{text_24}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 2,
      maxLines: 2
    }
  },
  variant: {
    open: {
      true: {
        'root-container': {
          hidden: false,
          transition: {
            'timing-function': '{easeJoyfulEntrance}'
          }
        }
      }
    },
    showClose: {
      false: {
        'close-jds_notification_button': {
          hidden: true
        },
        'right-slot': {
          hidden: false
        }
      }
    },
    _platform: {
      tablet: {
        'root-container': {
          'max-width': '{t_23}'
        }
      },
      desktop: {
        'root-container': {
          'max-width': '{t_24}'
        }
      }
    },
    _hasCTA: {
      false: {
        'buttons-container': {
          hidden: true
        }
      }
    },
    _hasDescription: {
      false: {
        'support-jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      false: {
        mobile: {
          'root-container': {
            'translate-y': '{size.max}'
          }
        },
        tablet: {
          'root-container': {
            'translate-x': '{size.negativeMax}'
          }
        },
        desktop: {
          'root-container': {
            'translate-x': '{size.negativeMax}'
          }
        }
      },
      true: {
        mobile: {
          'root-container': {
            'translate-y': 0
          }
        },
        tablet: {
          'root-container': {
            'translate-x': 0
          }
        },
        desktop: {
          'root-container': {
            'translate-x': 0
          }
        }
      }
    }
  ],
  combination_config: [['open', '_platform']],
  api: {
    config: {
      open: {
        values: [false, true]
      },
      showClose: {
        values: [true, false],
        doc_description: 'This shows close button on Toast when true.'
      },
      _platform: {
        values: ['mobile', 'tablet', 'desktop']
      },
      _hasCTA: {
        values: [true, false]
      },
      _hasDescription: {
        values: [true, false]
      }
    },
    data: {
      'root-container': {
        '_nudge.id': {
          type: 'NotificationId',
          name: 'id',
          required: true,
          doc_description: 'It will hold the reference of Toast'
        },
        dismissAfter: {
          type: 'number',
          name: 'dismissAfter'
        }
      },
      'secondary-jds_notification_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA',
          doc_description: 'It displays label of secondary button of Toast.'
        }
      },
      'primary-jds_notification_button': {
        label: {
          type: 'string',
          name: 'primaryCTA',
          doc_description: 'It displays label of primary button of Toast.'
        }
      },
      'heading-jds-text': {
        value: {
          type: 'string',
          name: 'title',
          doc_description: 'It displays the title of Toast.'
        }
      },
      'support-jds-text': {
        value: {
          type: 'string',
          name: 'description',
          doc_description: 'It can be used to add description to the Toast.'
        }
      }
    },
    events: {
      'root-container': {
        onShow: 'onShow',
        onUpdate: {
          name: 'onUpdate',
          platform: 'android'
        },
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onHoverEnd: {
          name: 'onHoverEnd',
          platform: 'web'
        },
        onSwipeDown: 'onClose'
      },
      'close-jds_notification_button': {
        onClick: 'onClose'
      },
      'secondary-jds_notification_button': {
        onClick: 'onSecondaryClick'
      },
      'primary-jds_notification_button': {
        onClick: 'onPrimaryClick'
      }
    },
    children: {
      'left-slot': {
        accepts: ['jds_icon', 'jds_avatar'],
        max: 1,
        name: 'prefix',
        doc_description: "It takes 'icon', 'avatar' as prefix."
      },
      'right-slot': {
        accepts: ['jds_notification_button'],
        max: 1,
        name: 'suffix',
        doc_description: "It takes 'jds_notification_button' as suffix."
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'alertdialog'
          }
        }
      },
      'close-jds_notification_button': {
        properties: {
          ariaLabel: {
            name: 'closeButtonAriaLabel',
            value: 'Close Toast'
          }
        }
      },
      'secondary-jds_notification_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'primary-jds_notification_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
